import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiSend, FiCheckCircle } from 'react-icons/fi';

export default function Contact() {
  const [formState, setFormState] = useState('idle');

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormState('submitting');
    setTimeout(() => setFormState('success'), 1500);
  };

  if (formState === 'success') {
    return (
      <section id="contact" className="py-32 bg-[#050505] px-6">
        <div className="max-w-3xl mx-auto glass-panel p-16 text-center border-[#DFFF00]">
          <div className="w-20 h-20 bg-[#DFFF00]/10 flex items-center justify-center mx-auto mb-8 rounded-full">
            <SafeIcon icon={FiCheckCircle} className="text-[#DFFF00] text-4xl" />
          </div>
          <h2 className="text-4xl font-black uppercase tracking-tighter text-white mb-4 italic">Request Logged.</h2>
          <p className="text-slate-400 text-lg mb-8">An Infrastructure Specialist will reach out within 24 hours to review your deployment protocol.</p>
          <button 
            onClick={() => setFormState('idle')}
            className="text-[#DFFF00] font-black uppercase tracking-widest text-xs border border-[#DFFF00]/20 px-8 py-4 hover:bg-[#DFFF00] hover:text-black transition-all"
          >
            Reset Form
          </button>
        </div>
      </section>
    );
  }

  return (
    <section id="contact" className="py-32 bg-[#050505] px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20">
          <div>
            <div className="flex items-center gap-3 mb-8">
              <span className="h-px w-12 bg-[#DFFF00]" />
              <span className="text-[#DFFF00] text-[10px] font-black uppercase tracking-[0.4em]">Initialize Protocol</span>
            </div>
            <h2 className="text-5xl md:text-7xl font-black uppercase tracking-tighter text-white mb-8 italic leading-none">
              Request <br /><span className="text-[#DFFF00]">Deployment.</span>
            </h2>
            <p className="text-slate-400 text-xl max-w-md leading-relaxed mb-12">
              Our infrastructure slots are strictly limited. Provide your operational details to begin the vetting process.
            </p>
            
            <div className="space-y-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 border border-white/10 flex items-center justify-center flex-shrink-0">
                  <span className="text-[#DFFF00] font-black italic">01</span>
                </div>
                <p className="text-slate-500 text-sm font-medium uppercase tracking-widest leading-loose">
                  Operational Review: We analyze your niche and target network saturation levels.
                </p>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 border border-white/10 flex items-center justify-center flex-shrink-0">
                  <span className="text-[#DFFF00] font-black italic">02</span>
                </div>
                <p className="text-slate-500 text-sm font-medium uppercase tracking-widest leading-loose">
                  Node Allocation: We assign dedicated IP blocks and account nodes for your brand.
                </p>
              </div>
            </div>
          </div>

          <div className="glass-panel p-10 md:p-16 relative">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-[10px] font-black uppercase tracking-widest text-slate-500">Full Name</label>
                  <input required type="text" className="w-full bg-white/5 border border-white/10 p-4 text-white focus:border-[#DFFF00] outline-none transition-all font-medium" />
                </div>
                <div className="space-y-2">
                  <label className="text-[10px] font-black uppercase tracking-widest text-slate-500">Work Email</label>
                  <input required type="email" className="w-full bg-white/5 border border-white/10 p-4 text-white focus:border-[#DFFF00] outline-none transition-all font-medium" />
                </div>
              </div>
              
              <div className="space-y-2">
                <label className="text-[10px] font-black uppercase tracking-widest text-slate-500">Target Network</label>
                <select className="w-full bg-white/5 border border-white/10 p-4 text-white focus:border-[#DFFF00] outline-none transition-all font-medium appearance-none">
                  <option className="bg-[#050505]">TikTok Infrastructure</option>
                  <option className="bg-[#050505]">Instagram Infrastructure</option>
                  <option className="bg-[#050505]">Facebook Infrastructure</option>
                  <option className="bg-[#050505]">AI Creative Assets Only</option>
                </select>
              </div>

              <div className="space-y-2">
                <label className="text-[10px] font-black uppercase tracking-widest text-slate-500">Operational Notes</label>
                <textarea rows="4" className="w-full bg-white/5 border border-white/10 p-4 text-white focus:border-[#DFFF00] outline-none transition-all font-medium resize-none" placeholder="Target niche, monthly goals, etc."></textarea>
              </div>

              <button 
                type="submit"
                disabled={formState === 'submitting'}
                className="w-full bg-[#DFFF00] text-black py-6 font-black uppercase tracking-[0.3em] text-sm flex items-center justify-center gap-3 hover:scale-[1.01] active:scale-[0.99] transition-all disabled:opacity-50"
              >
                {formState === 'submitting' ? 'Transmitting...' : 'Initiate Briefing'}
                <SafeIcon icon={FiSend} />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}